"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadow = exports.overlay = exports.green = exports.lightGreen = exports.yellow = exports.redGradient = exports.blueGradient = exports.darkenRed = exports.red = exports.darkenPrimary = exports.primary = exports.lightPrimary = exports.darkenWhite = exports.white = exports.lightWhite = exports.darkGrey = exports.darkenGrey = exports.grey = exports.lighterDark = exports.lightDark = exports.dark = void 0;
exports.dark = "#23292F";
exports.lightDark = "#363E47";
exports.lighterDark = "#6C7782";
exports.grey = "#D8D8D8";
exports.darkenGrey = "#AAACAD";
exports.darkGrey = "#6E767C";
exports.lightWhite = "#FBFCFF";
exports.white = "#F1F7FF";
exports.darkenWhite = "#DDE7F4";
exports.lightPrimary = "#63BCF8";
exports.primary = "#2780BB";
exports.darkenPrimary = "#135B8A";
exports.red = "#FB6C6C";
exports.darkenRed = "#8A1313";
exports.blueGradient = {
    from: exports.lightPrimary,
    to: exports.darkenPrimary
};
exports.redGradient = {
    from: exports.darkenRed,
    to: exports.red
};
exports.yellow = "#F6B141";
exports.lightGreen = "#8BEE73";
exports.green = "#44BB27";
exports.overlay = "rgba(35, 41, 47, 0.5)";
exports.shadow = {
    bluePrimary: "0px 2px 10px 2px rgba(14, 36, 51, 0.2)",
    white: "0px 2px 10px 2px rgba(23, 25, 27, 0.3)",
    dark: "0px 2px 10px 2px rgba(23, 25, 27, 0.3)"
};
//# sourceMappingURL=colors.js.map